import "core-js/modules/es.array.concat.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "inquiryList"
  }, [_c("a-card", [_c("a-form", {
    attrs: {
      layout: "inline"
    },
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.handleClickQueryButton.apply(null, arguments);
      }
    }
  }, [_c("a-row", [_c("a-col", {
    attrs: {
      md: 6,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("inquiryList.askPriceNoKeyword")
    }
  }, [_c("a-input", {
    attrs: {
      maxLength: 100,
      allowClear: "",
      placeholder: _vm.$t("inquiryList.askPriceNoKeywordPH")
    },
    model: {
      value: _vm.queryParam.askPriceNoKeyword,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "askPriceNoKeyword", $$v);
      },
      expression: "queryParam.askPriceNoKeyword"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      md: 6,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("inquiryList.erpCustomerKeyword")
    }
  }, [_c("a-input", {
    attrs: {
      maxLength: 100,
      allowClear: "",
      placeholder: _vm.$t("inquiryList.erpCustomerKeywordPH")
    },
    model: {
      value: _vm.queryParam.erpCustomerKeyword,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "erpCustomerKeyword", $$v);
      },
      expression: "queryParam.erpCustomerKeyword"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      md: 6,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("inquiryList.sellerCode")
    }
  }, [_c("a-select", {
    attrs: {
      allowClear: "",
      options: _vm.sellerList,
      placeholder: _vm.$t("inquiryList.sellerCodePH"),
      mode: "multiple",
      maxTagCount: 1
    },
    model: {
      value: _vm.queryParam.sellerCode,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "sellerCode", $$v);
      },
      expression: "queryParam.sellerCode"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      md: 6,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("inquiryList.date")
    }
  }, [_c("date-range", {
    staticClass: "middleClass",
    attrs: {
      endDate: _vm.queryParam.endDate,
      startDate: _vm.queryParam.startDate
    },
    on: {
      change: _vm.handleDateChange
    }
  })], 1)], 1), _c("a-col", {
    staticClass: "button-wrapper",
    attrs: {
      span: 24
    }
  }, [_c("a-form-item", [_c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.handleClickQueryButton
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("publicuse.inquire2")) + " ")])], 1)], 1)], 1)], 1)], 1), _c("a-card", {
    staticClass: "table-wrapper"
  }, [_c("a-row", {
    attrs: {
      type: "flex",
      justify: "end"
    }
  }, [_c("a-col", {
    staticStyle: {
      "margin-bottom": "16px"
    }
  }, [_c("a-button", {
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      loading: _vm.syncLoading
    },
    on: {
      click: _vm.syncErpRequestPriceFuc
    }
  }, [_vm._v(_vm._s(_vm.$t("inquiryList.syncQuote")))])], 1)], 1), _c("a-table", {
    attrs: {
      loading: _vm.tableLoading,
      columns: _vm.columns,
      dataSource: _vm.tableData,
      pagination: {
        "show-quick-jumper": true,
        "show-size-changer": true,
        showTotal: function showTotal(total) {
          return "".concat(_vm.$t("public.total"), "\uFF1A").concat(total);
        },
        total: _vm.total,
        current: _vm.queryParam.page,
        pageSize: _vm.queryParam.size
      }
    },
    on: {
      change: _vm.hangeTableChange
    },
    scopedSlots: _vm._u([{
      key: "askPriceNo",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("router-link", {
          staticClass: "underline",
          attrs: {
            target: "_blank",
            to: {
              path: "/inquiryDetail",
              query: {
                id: record.id
              }
            }
          }
        }, [_vm._v(" " + _vm._s(text) + " ")])], 1);
      }
    }, {
      key: "erpCustomerName",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("router-link", {
          staticClass: "underline",
          attrs: {
            target: "_blank",
            to: {
              path: "/customermanager/editcustomer2",
              query: {
                erpCustomerId: record.erpCustomerId
              }
            }
          }
        }, [_c("div", [_vm._v(_vm._s(text))]), _c("div", [_vm._v(_vm._s(record.erpCustomerCode))])])], 1);
      }
    }, {
      key: "status",
      fn: function fn(text, record) {
        return _c("span", {}, [_vm._v(" " + _vm._s(text == 1 ? _vm.$t("inquiryList.submitted") : _vm.$t("inquiryList.completed")) + " ")]);
      }
    }, {
      key: "action",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("router-link", {
          attrs: {
            target: "_blank",
            to: {
              path: "/inquiryDetail",
              query: {
                id: record.id
              }
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("inquiryList.detail")) + " ")])], 1);
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };